const DEFAULT_FABRIC = 'P-2027' as const
const DEFAULT_SIZE = 'M' as const

export { DEFAULT_FABRIC, DEFAULT_SIZE }
